import { ApiResponse, OptionModel } from 'src/types/api-response';
import { LoSamLoaiCamera } from 'src/types/camera';
import { HTBaiViet } from 'src/types/htblog';
import { ThongBao } from 'src/types/notification';
import { apiGet, buildQueryString } from './api-client';

// ----------------------------------------------------------------------
// HOME API SERVICE (Public endpoints - no authentication required)
// ----------------------------------------------------------------------

export const homeAPI = {
  async listHomeBaiViet(params?: any): Promise<ApiResponse<HTBaiViet>> {
    const queryString = buildQueryString(params);
    return apiGet<ApiResponse<HTBaiViet>>(
      `/Home/ListBaiViet${queryString}`,
      undefined,  
      'Lấy danh sách bài viết trang chủ thất bại. Vui lòng thử lại.'
    );
  }, 

  async getBlogHome(slug: string): Promise<ApiResponse<HTBaiViet>> {
    return apiGet<ApiResponse<HTBaiViet>>(
      `/Home/BaiViet/${slug}`,
      undefined,
      'Lấy bài viết thất bại. Vui lòng thử lại.'
    );
  },
 
  async OptionLoSamLoaiTuoi(): Promise<ApiResponse<OptionModel>> {
    return apiGet<ApiResponse<OptionModel>>(
      '/Home/OptionLoSamLoaiTuoi',
      undefined,
      'Lấy danh sách loại tuổi thất bại. Vui lòng thử lại.'
    );
  },

  async OptionLoSamLoaiCamera(): Promise<ApiResponse<LoSamLoaiCamera>> {
    return apiGet<ApiResponse<LoSamLoaiCamera>>(
      '/Home/OptionLoSamLoaiCamera',
      undefined,
      'Lấy danh sách loại camera thất bại. Vui lòng thử lại.'
    );
  },

  async OptionCaySamTinhTrang(): Promise<ApiResponse<OptionModel>> {
    return apiGet<ApiResponse<OptionModel>>(
      '/Home/OptionCaySamTinhTrang',
      undefined,
      'Lấy danh sách tình trạng thất bại. Vui lòng thử lại.'
    );
  },

  async OptionCaySamDiemSucKhoe(): Promise<ApiResponse<OptionModel>> {
    return apiGet<ApiResponse<OptionModel>>(
      '/Home/OptionCaySamDiemSucKhoe',
      undefined,
      'Lấy danh sách điểm sức khỏe thất bại. Vui lòng thử lại.'
    );
  },
   async OptionVuonTrong(): Promise<ApiResponse<OptionModel>> {
    return apiGet<ApiResponse<OptionModel>>(
      '/Home/OptionVuonTrong',
      undefined,
      'Lấy danh sách điểm sức khỏe thất bại. Vui lòng thử lại.'
    );
  },
};

// ----------------------------------------------------------------------
// NOTIFICATION API SERVICE
// ----------------------------------------------------------------------

export const thongbaoApiSerice = {
  async Notifications(params?: {
    skip?: number;
    take?: number;
    Status?: number;
    rowCount?: number;
    searchBy?: string[]; 
    orderBy?: string[];
  }): Promise<ApiResponse<ThongBao>> {
    const queryString = buildQueryString(params);
    return apiGet<ApiResponse<ThongBao>>(
      `/ThongBao/ListThongBao${queryString}`,
      'ThongBao',
      'Không thể tải danh sách thông báo'
    );
  },
  async seenThongBao(id: number): Promise<ApiResponse<ThongBao>> {
    return apiGet<ApiResponse<ThongBao>>(
      `/ThongBao/SeenThongBao/${id}`, // Truyền ID trực tiếp vào URL
      'ThongBao',
      'Không thể cập nhật trạng thái thông báo'
    );
  },

  async seenThongBaoAll(): Promise<ApiResponse<ThongBao>> {
    return apiGet<ApiResponse<ThongBao>>(
      '/ThongBao/SeenThongBaoAll',
      'ThongBao',
      'Không thể đánh dấu đã đọc tất cả'
    );
  },
};

export default { homeAPI, thongbaoApiSerice };